import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { FeaturedProperties } from "@/components/home/FeaturedProperties";
import { TestimonialsPreview } from "@/components/home/TestimonialsPreview";
import { CTASection } from "@/components/home/CTASection";
import { SEO } from "@/components/SEO";
import { LocalBusinessJsonLd } from "@/components/JsonLd";
import { useCompanyInfo } from "@/hooks/use-company-info";

const Index = () => {
  const { company_name, phone, email, address } = useCompanyInfo();

  return (
    <Layout>
      <SEO 
        description="Discover exceptional vacation rentals, commercial spaces, and long-term homes. Your trusted partner for premium property management."
        keywords="real estate, vacation rentals, commercial properties, long-term rentals, property management"
        url="https://morganlandcompany.lovable.app"
      />
      <LocalBusinessJsonLd
        name={company_name}
        description="Discover exceptional vacation rentals, commercial spaces, and long-term homes. Your trusted partner for premium property management."
        phone={phone}
        email={email}
        address={address}
      />
      <HeroSection />
      <FeaturedProperties />
      <TestimonialsPreview />
      <CTASection />
    </Layout>
  );
};

export default Index;
